module.exports = __webpack_public_path__ + "static/media/mylogo.b8d3a561.png";